<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Usuarios</h2>
    <button
      class="btn btn-primary"
      id="agregarUsuario"
      (click)="abrirModoCreacionUsuario()"
    >
      Agregar Usuario
    </button>
    <app-usuario-modal></app-usuario-modal>
    <div class="table-responsive">
      <table id="tablaUsuarios" class="table table-striped table-bordered">
        <thead>
          <tr></tr>
        </thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
</div>
